import { __assign } from "tslib";
import { getTestOptionIndexes } from '../../internal/components/options-list/utils/test-indexes';
export var getItemProps = function (_a) {
    var _b;
    var option = _a.option, index = _a.index, getOptionProps = _a.getOptionProps, filteringValue = _a.filteringValue, _c = _a.isKeyboard, isKeyboard = _c === void 0 ? false : _c, _d = _a.checkboxes, checkboxes = _d === void 0 ? false : _d;
    var optionProps = getOptionProps(option, index);
    optionProps.filteringValue = filteringValue;
    var _e = getTestOptionIndexes(option) || {}, inGroupIndex = _e.inGroupIndex, groupIndex = _e.groupIndex, throughIndex = _e.throughIndex;
    return __assign(__assign({}, optionProps), (_b = { isKeyboard: isKeyboard, hasCheckbox: checkboxes }, _b['data-group-index'] = groupIndex, _b['data-child-index'] = inGroupIndex, _b['data-test-index'] = throughIndex, _b));
};
//# sourceMappingURL=get-item-props.js.map